import datapoints from '../datapoints';
import { returnTopExecutingActionDatapoint } from 'owa-analytics';
import { ActionSource, createLegacyActionWithDatapoint } from 'owa-analytics-actions';
import deleteConversationStoreUpdate from 'owa-mail-actions/lib/triage/deleteConversationStoreUpdate';
import { getRowIdsFromRowKeys } from 'owa-mail-list-store';
import TableView from 'owa-mail-list-store/lib/store/schema/TableView';
import listViewStore from 'owa-mail-list-store/lib/store/Store';
import { handleServerResponseSuccessAndError } from 'owa-mail-triage-action-response-processor';
import { setConversationInferenceClassificationService } from 'owa-mail-triage-action/lib/services/setConversationInferenceClassificationService';
import * as undoActions from 'owa-mail-undo';
import FocusedViewFilter from 'owa-service/lib/contract/FocusedViewFilter';

/**
 * move to focused/other action
 * @param conversationRowKeys the specified rowKeys
 * @param tableViewId the table view id
 * @param actionSource the source that initiated this action
 * @return the action response
 */
export default createLegacyActionWithDatapoint(
    'moveConversationToFocusedOrOtherAction',
    datapoints.moveConversationToFocusedOrOther
)(function moveConversationToFocusedOrOther(
    conversationRowKeys: string[],
    tableViewId: string,
    toViewFilter: FocusedViewFilter,
    actionSource: ActionSource
): Promise<void> {
    const tableView: TableView = listViewStore.tableViews.get(tableViewId);
    const isFocusedView: boolean = toViewFilter == FocusedViewFilter.Focused;
    const conversationIdStrings = getRowIdsFromRowKeys(conversationRowKeys, tableViewId);

    undoActions.clearLastUndoableAction();

    const setInferenceClassificationPromise = setConversationInferenceClassificationService(
        conversationIdStrings,
        isFocusedView ? 'Focused' : 'Other'
    );

    returnTopExecutingActionDatapoint().markUserPerceivedTime();

    // remove conversation from list view and reading pane store
    // VSO 20053:Tombstone not working when moving conversation from focused to other
    deleteConversationStoreUpdate(conversationIdStrings, tableView, 'Move');

    return setInferenceClassificationPromise.then(response => {
        return handleServerResponseSuccessAndError(response);
    });
});
